import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Layout } from "antd";
import "./App.css";
import Header from "./Page/Header/Header";
import Home from "./Page/Home/Home";
import Login from "./Page/Login/Login";
import Tender from "./Page/Tender/Tender";
import Invitation from "./Page/Invitation/Invitation";
import InvitationList from "./Page/Invitation/InvitationList/InvitationList";
import JoinWork from "./Page/JoinWork/JoinWork";
import JoinWorkDtl from "./Page/JoinWork/JoinWorkDtl";
import JoinWorkInvitation from "./Page/JoinWork/JoinWorkInvitation";
import Vendors from "./Page/Vendors/VendorList";
import Configuration from "./Page/Config/Configuration";
import TabeauReport from "./Page/TableauReport/TabeauReport";
import { LoadScreen } from "./Components/LoadScreen/LoadScreen";
import UserContext from "./Page/UserContext/UserContext";
class App extends Component {
  constructor(props)
  {
    super(props)
    this.state = {
      permission: {},
    };
    this.changeSMenu = this.changeSMenu.bind(this)
    this.getPermission = this.getPermission.bind(this)
    this.successLogin = this.successLogin.bind(this)
  }
  changeSMenu = (sMenu) => {
    this.setState({
      sMenu: sMenu,
    });
  };

  getPermission = (permission) => {
    this.setState({
      permission: {
        isHold: permission.isHold.toString(),
        isReopen: permission.isReopen.toString(),
        isCancel: permission.isCancel.toString(),
        isClose: permission.isClose.toString(),
        isAdmin: permission.isAdmin.toString(),
        isJWAdmin: permission.isJWAdmin.toString(),
      }
    });
  }
  successLogin = (username, basecompany, positionname, userid) => {
    localStorage.setItem("username", username);
    localStorage.setItem("basecompany", basecompany);
    localStorage.setItem("positionname", positionname);
    localStorage.setItem("userid", userid);

    this.setState({
      isAuth: true,
      userid: userid,
      username: username,
      basecompany: basecompany,
      positionname: positionname,
    });
  };

  logOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("basecompany");
    localStorage.removeItem("positionname");
    localStorage.removeItem("userid");
    localStorage.removeItem("permission");

    this.setState({
      isAuth: false,
      username: null,
      basecompany: null,
      positionname: null,
      userid: 0,
      permission: {}
    });
  };

  componentDidMount() {
    let expires_at = localStorage.getItem("expires_at");
    let token = localStorage.getItem("access_token");
    if (token) {
      let username = localStorage.getItem("username");
      let basecompany = localStorage.getItem("basecompany");
      let positionname = localStorage.getItem("positionname");
      let userid = localStorage.getItem("userid");
      let isHold = localStorage.getItem("isHold");
      let isReopen = localStorage.getItem("isReopen");
      let isCancel = localStorage.getItem("isCancel");
      let isClose = localStorage.getItem("isClose");
      let isAdmin = localStorage.getItem("isAdmin");
      let isJWAdmin = localStorage.getItem("isJWAdmin");
      if (username && basecompany && userid) {
        this.setState({
          isAuth: true,
          userid: userid,
          username: username,
          basecompany: basecompany,
          positionname: positionname,
          permission: { empid: userid, isHold: isHold, isReopen: isReopen, isCancel: isCancel, isClose: isClose, isAdmin: isAdmin, isJWAdmin: isJWAdmin }

        });
       
      }
      
    } else {
      this.logOut();
    }
  }
  

  render() {
    let v_router = null;
    if (this.state.isAuth) {
      v_router = (
        <div>
          <Header username={this.state.username} logout={this.logOut}></Header>
          <div style={{ height: "48px" }}></div>
          <Switch>
            <Route path="/home">
              <Home></Home>
            </Route>
            {/* <Route path="/tender">
              <Tender></Tender>
            </Route> */}
            <Route path="/tender/:index">
              <Tender></Tender>
            </Route>
            {/* <Route path="/invitation/:invitationid/:tenderid/:opening"> */}
            <Route path="/invitation/:invitationid/:tenderid/:tendername/:department/:typename/:purchasemethod/:budget/:isedit/:opening">
              <Invitation />
            </Route>
            <Route path="/invitationList">
              <InvitationList></InvitationList>
            </Route>
            <Route path="/joinwork">
              <JoinWork successLogin={this.successLogin}></JoinWork>
            </Route>
            <Route path="/joinworkdtl/:joinworkid/:joinname/:joincode/:department/:typename/:startdate/:enddate">
              <JoinWorkDtl successLogin={this.successLogin}></JoinWorkDtl>
            </Route>
            {/* <Route path="/joinworkinvitation/:joinworkid/:joinname/:joincode/:department/:typename/:startdate/:enddate/:status"> */}
            <Route path="/joinworkinvitation/:joinworkid">
              <JoinWorkInvitation />
            </Route>
            <Route path="/vendors">
              <Vendors></Vendors>
            </Route>
            <Route path="/report">
              <TabeauReport></TabeauReport>
            </Route>
            {this.state.permission.isAdmin === "1" ?
              <Route path="/config">
                <Configuration></Configuration>
              </Route> : null}
          </Switch>
        </div>
      );
    } else {
      v_router = (
        <Switch>
          <Route path="/">
            <Login getPermission={this.getPermission} successLogin={this.successLogin}></Login>
          </Route>
          <Route path="/login">
            <Login getPermission={this.getPermission} successLogin={this.successLogin}></Login>
          </Route>
        </Switch>
      );
    }

    return (
      <div className="App">
        <Router>
          <UserContext.Provider
            value={{
              userid: this.state.userid,
              username: this.state.username,
              basecompany: this.state.basecompany,
              permission: this.state.permission
            }}
          >
            {v_router}
          </UserContext.Provider>

          <LoadScreen />
        </Router>
      </div>
    );
  }
}

export default App;
